import { useEffect, useState } from "react";
import { api, formatDateTime } from "@/lib/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => { api.get("/audit-log").then(r => setLogs(r.data)); }, []);
  const filtered = logs.filter(l => !filter || l.action.includes(filter) || l.entity.includes(filter) || l.user_email.includes(filter));

  return (
    <div className="p-4 sm:p-8 space-y-5">
      <header>
        <h1 className="text-2xl sm:text-3xl font-serif-display font-bold">Audit Log</h1>
        <p className="text-sm text-[#536263]">Jejak semua aksi penting · tidak dapat dihapus</p>
        <div className="mt-2 h-px w-12 bg-[#B87333]"></div>
      </header>
      <input placeholder="Cari aksi, entitas, atau email..." value={filter} onChange={e => setFilter(e.target.value)}
        className="w-full border border-[#E2DDD3] rounded-lg px-3 h-11" data-testid="audit-search" />
      <div className="space-y-1" data-testid="audit-list">
        {filtered.map(l => (
          <div key={l.id} className="card-editorial p-3 flex items-start gap-3 text-sm">
            <div className="min-w-[120px] text-xs text-[#8A999A]">{formatDateTime(l.timestamp)}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="chip bg-[#0F5257] text-white">{l.action}</span>
                <span className="chip bg-[#F2EEE7] text-[#536263]">{l.entity}</span>
                <span className="text-xs text-[#8A999A]">{l.user_email} ({l.user_role})</span>
              </div>
              {(l.before || l.after) && (
                <pre className="mt-2 bg-[#FAF7F2] rounded p-2 text-[10px] overflow-x-auto">
                  {JSON.stringify({ before: l.before, after: l.after }, null, 2)}
                </pre>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
